import React, { useEffect, useState } from "react";
import { Button, Grid, Paper, Stack, Typography, FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";

import EventBookingTableComponent from "../../../components/admin/event-booking-manager/EventBookingTable";
import { EventBookingAddDrawer } from "../../../components/admin/event-booking-manager/EventBookingAddDrawer";

import { SearchRecords } from "../../../components/Common/SearchRecords";
import { defaultPaginate, PERMISSIONS } from "../../../helpers/constants";
import { useGetEventBookingListQuery } from "../../../store/events/eventsApis";
import HasPermission from "../../../components/Common/HasPermission";

const EventBookingsContainer = (props) => {
    const { showDrawer, formType, initialValues, pagination } = props;
    const [paymentStatusFilter, setPaymentStatusFilter] = useState("All");
    
    // Build query params - only include payment_status if it's not "All"
    const queryParams = { ...pagination };
    if (paymentStatusFilter !== "All") {
        queryParams.payment_status = paymentStatusFilter;
    }
    
    const { isLoading, data: bookings, isFetching, refetch } = useGetEventBookingListQuery(queryParams);

    useEffect(() => {
        props.handlePaginationState({ ...defaultPaginate, sortField: "booking_id" });
    }, []);

    const handleAddBooking = () => {
        props.changeBookingInitialState({
            showDrawer: true,
            formType: "Add",
            initialValues: null,
        });
    };

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    };

    const handleDrawerClose = () => {
        props.changeBookingInitialState({ showDrawer: false, formType: "", initialValues: null });
    };

    const handleBookingEdit = (data, type) => {
        let payload = { ...data };
        delete payload.createdAt;
        props.changeBookingInitialState({ showDrawer: true, formType: type, initialValues: payload });
    };

    const handlePaymentStatusChange = (event) => {
        const value = event.target.value;
        setPaymentStatusFilter(value);
        // Reset to first page when filter changes
        handlePagination({
            ...pagination,
            pageNo: 0,
        });
    };

    return (
        <Stack spacing={1}>
            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item xs={6} sx={{ alignSelf: "center" }}>
                        <Typography variant="h6">List of Event Bookings</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sx={{ alignSelf: "center" }}
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"flex-end"}
                        gap={2}
                    >
                        <Box sx={{ minWidth: 150 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Payment Status</InputLabel>
                                <Select
                                    value={paymentStatusFilter}
                                    label="Payment Status"
                                    onChange={handlePaymentStatusChange}
                                >
                                    <MenuItem value="All">All</MenuItem>
                                    <MenuItem value="Success">Success</MenuItem>
                                    <MenuItem value="Pending">Pending</MenuItem>
                                    <MenuItem value="Failed">Failed</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                        <HasPermission permission={PERMISSIONS.ORDERS.EVENT_BOOKING.CREATE} fallback={null}>
                            <Button
                                disableElevation
                                variant="contained"
                                sx={{ borderRadius: "50px" }}
                                onClick={() => handleAddBooking()}
                            >
                                Create Booking
                            </Button>
                        </HasPermission>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, color: "#071B2A", fontWeight: "400" }} elevation={0}>
                        <EventBookingTableComponent
                            edit={(val, type) => handleBookingEdit(val, type)}
                            loading={isLoading}
                            fetching={isFetching}
                            count={bookings?.count}
                            data={bookings?.result || []}
                            pagination={pagination}
                            handlePagination={(val) => handlePagination(val)}
                            refetch={refetch}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <EventBookingAddDrawer
                show={showDrawer}
                close={handleDrawerClose}
                formType={formType}
                initialValues={initialValues}
                getEventsList={props.getEventsList}
                getMembersList={props.getMembersList}
            />
        </Stack>
    );
};

export default EventBookingsContainer;
